import { FEEDERLISTS } from "../_constants/actionConstants";

const feederListInitialState = {
  locationTypeList: [],
  tradeList: [],
  miscMaterialsUnitsOfMeasure: [],
  fieldTestTypes: [],
  miscSessionData: {}, // Normalized by tabId
  fetching: false,
  error: null,
};

export const reducer = (state = feederListInitialState, action) => {
  switch (action.type) {
    case FEEDERLISTS.FETCH:
    case FEEDERLISTS.FETCH_LOOKUP_LISTS:
    case FEEDERLISTS.FETCH_ALL_TRADES:
    case FEEDERLISTS.FETCH_LOCATION_TYPES:
    case FEEDERLISTS.REFRESH:
      return { ...state, fetching: true };

    case FEEDERLISTS.FETCH_FULFILLED:
    case FEEDERLISTS.REFRESH_FULFILLED: {
      return {
        ...state,
        fetching: false,
      };
    }

    case FEEDERLISTS.FETCH_LOOKUP_LISTS_FULFILLED: {
      const { tradeList, locationTypeList, miscMaterialsUnitsOfMeasure, fieldTestTypes } =
        action;
      if (
        !tradeList ||
        !locationTypeList ||
        !miscMaterialsUnitsOfMeasure ||
        !fieldTestTypes
      )
        return { ...state, fetching: false };

      return {
        ...state,
        tradeList,
        locationTypeList,
        miscMaterialsUnitsOfMeasure,
        fieldTestTypes,
        fetching: false,
      };
    }

    case FEEDERLISTS.FETCH_ALL_TRADES_FULFILLED: {
      const { tradeList } = action;
      if (!tradeList) return { ...state, fetching: false };

      return { ...state, tradeList, fetching: false };
    }

    case FEEDERLISTS.CLEAR_ALL:
      return feederListInitialState;

    default:
      return state;
  }
};
